module.exports = __webpack_public_path__ + "static/img/292_phase_function_Paper_Points.132a906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/292_phase_function_Paper_Points.png
// module id = xWri
// module chunks = 0